// @flow
import React, { memo, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  updateSuccess,
  updateUserRequest,
} from '../../../pages/Account/redux/actions';
import {
  coutingVideoAlbum,
  updateAlbumBadgeCount,
} from '../../../pages/Album/redux/actions';
import { updateVideoRequest } from '../../../pages/Video/redux/actions';
import API, { ROUTES } from '../../api/api';
import IMAGES from '../../constans/images';
import ROUTERS from '../../constans/router';

type Props = {
  tabHeadings: Array,
  tabContents: Array,
  activeIndex: number,
  handleChangeTab: any,
  user: Object,
};

const TabsComponent = ({
  tabHeadings,
  tabContents,
  activeIndex,
  handleChangeTab,
  user,
}: Props) => {
  const [index, setIndex] = useState(activeIndex);
  const dispatch = useDispatch();

  const _handleChangeTab = (index) => {
    if (index === 3 && user.album_badge_count > 0) {
      //update album_badge_count user table
      var formData = new FormData();
      formData.append('album_badge_count', 0);
      dispatch(updateUserRequest(formData));

      dispatch(updateVideoRequest({id: 'all'}));
    }
    if (typeof handleChangeTab == 'function') {
      handleChangeTab(index);
    }
    setIndex(index);
  };

  return (
    <div className="tabs">
      <div className="tabs__style1">
        <div className="tabs__heading wrap">
          <ul className="tabs__heading__list">
            {tabHeadings.map((item, k) => {
              let badgeDot =
                user?.album_badge_count > 0 && item === '영상편지'
                  ? 'badge-dot-noti'
                  : '';
                let comingSoon = process.env.REACT_APP_DISABLED_VIDEO_MESSAGE === 'true' && item === '영상편지' ? 'disabled' : ''
              
              return (
                <li
                  onClick={comingSoon === '' ? () => _handleChangeTab(k) : ''}
                  key={k}
                  className={
                    `tabs__heading__item ${badgeDot} ${comingSoon}` +
                    (k === index ? 'active' : '')
                  }
                >
                  {item}
                  {
                    badgeDot !== '' && <span className="red-dot"></span>
                  }
                </li>
              );
            })}
          </ul>
          {/*<div className="tabs__heading_underline"></div>*/}
        </div>
        <div className="tabs__content">
          {tabContents.map((item, k) => {
            return (
              <div
                key={k}
                className={
                  'tabs__content__section ' + (k === index ? 'active' : '')
                }
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

TabsComponent.defaultProps = {
  activeIndex: 0,
  handleChangeTab: false,
};

export default memo(TabsComponent);
